(() => {
  'use strict';

  const roots = document.querySelectorAll('[data-aigclub-tool-directory]');
  for (const root of roots) {
    const input = root.querySelector('[data-aigclub-tool-search]');
    const cards = [...root.querySelectorAll('[data-aigclub-tool-card]')];
    const status = root.querySelector('[data-aigclub-tool-status]');
    const empty = root.querySelector('[data-aigclub-empty]');
    if (!input || !status || !empty || cards.length !== 120) continue;

    const apply = (rawQuery) => {
      const query = String(rawQuery ?? '').slice(0, 100).trim().toLocaleLowerCase('en');
      let visible = 0;
      for (const card of cards) {
        const match = query === '' || card.dataset.search.includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      }
      empty.hidden = visible !== 0;
      status.textContent = query === ''
        ? `Showing all ${visible} implemented tools.`
        : `Showing ${visible} of ${cards.length} implemented tools.`;
    };

    const initialQuery = new URLSearchParams(window.location.search).get('q') ?? '';
    input.value = initialQuery.slice(0, 100);
    apply(input.value);
    input.addEventListener('input', () => {
      input.value = input.value.slice(0, 100);
      apply(input.value);
    });
    root.querySelector('form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      apply(input.value);
    });
  }
})();
